"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getClientId(clientShortHandName, isProduction) {
    if (isProduction === void 0) { isProduction = false; }
    if (!clientShortHandName) {
        return '';
    }
    var prodClientIds = function (k) {
        return ({
            AP: '520204a6411c7a8838000000',
            ASK: '53284a90421c7a5602000004',
            BTI: '50cf3a14421c7a895d000004',
            BYN: '53284b28421c7a4f03000003',
            DNB: '5698d5066c09e50a026ab4fe',
            DP: '5f3258a8dd8fb6157309cb78',
            E24: '4d46b0cd74dea2fd799a0000',
            MPL: '556ec2cb854e7b72691c97d5',
            SA: '50cf3c40421c7a186400000e',
            SCH: '55841aa52d09e5f666ac46b7',
            STR: '53284b60421c7a6a03000004',
            VG: '54d9ffc5cba79ca80f8b456b',
            VNY: '53284b75421c7ad603000003',
        }[k]);
    };
    var testClientIds = function (k) {
        return ({
            AP: '510fb7e1efd04bf00d000000',
            ASK: '52f219fcefd04b5f10000002',
            BTI: '5037826aefd04b6471000000',
            BYN: '52f21a05efd04b5311000008',
            DNB: '56a765030277d01d1e50b52d',
            DP: '5ec7802ff31f45007751c809',
            E24: '4f33d9beefd04ba23b00001c',
            MPL: '556ec274e93a04c55d606ee5',
            SA: '506c29eaefd04b147c000001',
            SCH: '55841a6cc4609cd31f0e79e4',
            STR: '52f21a16efd04bc30e000002',
            VG: '54aa5bf7d067286169efec5b',
            VNY: '52f21a29efd04b062d000002',
        }[k]);
    };
    return isProduction
        ? prodClientIds(clientShortHandName)
        : testClientIds(clientShortHandName);
}
exports.default = getClientId;
//# sourceMappingURL=getClientId.js.map